/* eslint-disable no-unneeded-ternary */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { Breadcrumbs, InfiniteScroll, TBreadcrumb, TTabItem, Tabs } from 'src/components/common';
import Header from 'src/components/header/Header';

import {
  ProgramActions,
  ProgramDetails
} from 'src/components/company/programs/program';

import { TGetProgramRequest } from 'src/services/apiEndpoint.types.ts';

import {
  getEvent,
  getProgram,
  incrementApplicantsPage,
  incrementProgramMembersPage,
  resetViewProgram
} from 'src/store/program/program.slice';

import { useAppDispatch, useAppSelector } from 'src/store/hooks';

import { TViewProgramTabs } from './viewProgram.types';
import './viewProgram.scss';

const ViewEvent = () => {
  // Hooks
  const { paramValue } = useUrlParamValue();
  const { getIdentities } = useGetIdentity();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { viewEvent, moreApplicantsLeft, moreProgramMembersLeft } = useAppSelector(
    (store:any) => store.program
  );

  const loading: boolean = useAppSelector((store) => store.common.loading);

  const currentTab: TViewProgramTabs = paramValue({ paramName: 'tab' }) as TViewProgramTabs;
  const eventId: string = paramValue({ paramName: 'id' }) as string;
  const { loggedInUserType, loggedInCompanyId, authenticatedId } = getIdentities();
  const handleChangeTab = (value: string) => {
    const params: string = `id=${eventId}&tab=${value as TViewProgramTabs}`;
    navigate(`/view-event?${params}`);
  };

  const handleViewCompany = () => {
    const viewSelfCompany: boolean =
      loggedInUserType === 'Company' && loggedInCompanyId === viewEvent?.companyId;
    navigate(
      viewSelfCompany
        ? '/my-company?tab=events'
        : `/view-company?id=${viewEvent?.companyId}&tab=events`
    );
  };

  const breadCrumbs: TBreadcrumb[] = [
    { label: 'Company Profile', url: '', onClick: handleViewCompany },
    { label: 'Event Details', url: '' }
  ];
  const handleGetEvent = () => {
    const payload: TGetProgramRequest = {
      eventId,
      // userId: authenticatedId,
      userType: 'Company'
    };
    dispatch(getEvent(payload));
  };
  const tabItems: TTabItem[] = [
    {
      key: 'eventDetails',
      text: 'Event Details',
      disabled: false,
      component: <ProgramDetails templateType='Event'/>
    }
  ];

  const loadMoreItems = () => {
    switch (currentTab) {
      case 'submittedApplications': {
        if (moreApplicantsLeft && !loading) {
          dispatch(incrementApplicantsPage(1));
        }
        break;
      }
      case 'programMembers': {
        if (moreProgramMembersLeft && !loading) {
          dispatch(incrementProgramMembersPage(1));
        }
        break;
      }
      default: {
        break;
      }
    }
  };

  const moreItemsLeft =
    currentTab === 'submittedApplications'
      ? moreApplicantsLeft
      : currentTab === 'programMembers'
        ? moreProgramMembersLeft
        : false;
  const showFooter =
    currentTab === 'submittedApplications' || currentTab === 'programMembers' ? true : false;
  useEffect(() => {
    handleGetEvent();
    return () => {
      dispatch(resetViewProgram());
    };
  }, []);
  // useEffect(() => {
  //  const companyid:any = StorageUtils.get('companyId')
  //  console.log(viewProgram, 'viewProgram?.companyId', companyid)
  //   if (viewProgram?.companyId && viewProgram?.companyId !== companyid) {
  //        navigate('/')
  //   }
  // }, [viewProgram]);

  return (
    <InfiniteScroll
      className="view-program"
      onScrollEnd={loadMoreItems}
      loading={loading}
      moreItemsLeft={moreItemsLeft}
      showFooter={showFooter}
      showLoader={true}
    >
      <Header />
      <div className="view-program__body">
        <Breadcrumbs breadcrumbs={breadCrumbs} />
        <ProgramActions
          status={viewEvent?.status}
          programId={eventId}
          handleGetProgram={handleGetEvent}
          companyId={viewEvent?.companyId}
          templateType='Event'
        />
        <Tabs activeItem={currentTab} onTabChange={handleChangeTab} items={tabItems} />
      </div>
    </InfiniteScroll>
  );
};

export default ViewEvent;
